// NOTE: dto
export const helloRequest = {};

export const helloResponse = {};

// NOTE: state
export const initialHelloState = {
  isPageLoading: false,
  show: true,
};
